module.exports = __webpack_public_path__ + "static/media/1124_tapestry_2K.2d854798.glb";